import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "./Components/Access";
import Navbar from "./Components/Navbar";

const FacturationEpfl = (props) =>
{
    const purple = '#6571FE';

    async function mount()
    {
    }

    useEffect(() =>
    {
        if (!props.user) {
            props.getUser()
        }
        else {
            mount();
        }
    }, [props.user])




	return (
        <Access needConnection={true}  type_user={[1, 2]}>
            <Navbar user={props.user} />

            <div style={{display: 'flex'}}>
                <div style={{flex: 1, margin: 20, display: 'flex'}}>
                    <div style={{flex: 1, display: 'flex'}}>
                        <p>EPFL</p>
                        <p style={{marginLeft: 5}}>\</p>
                        <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Outil de facturation</p>
                    </div>
                    <div style={{flex: 1}}>
                        {props.user?
                        <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                        :null}
                    </div>
                    <div style={{flex: 1}}></div>
                </div>
            </div>

        </Access>
	);
}

export default FacturationEpfl;
